import { render, staticRenderFns } from "./journalLink.vue?vue&type=template&id=287c80ef&scoped=true"
import script from "./journalLink.vue?vue&type=script&lang=js"
export * from "./journalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287c80ef",
  null
  
)

export default component.exports